import styled from 'styled-components'

import { ButtonWithIcon } from '@components/ui/Buttons'
import { Input } from '@components/ui/InputElements'
import { Typography } from '@components/ui/Typography'

export const Wrapper = styled.div`
  height: 36px;
  margin-top: 5px;
  border: 1px solid ${({ theme }) => theme.colors.gray[120]};
  padding-left: 10px;
  border-radius: 4px;
  width: 100%;
  display: flex;
  gap: 12px;
  background-color: ${({ theme }) => theme.colors.gray[0]};

  ${ButtonWithIcon} {
    flex-shrink: 0;
    height: 100%;
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
    &,
    &:hover {
      border-left-color: ${({ theme }) => theme.colors.gray[120]};
    }
  }
`

export const StyledInput = styled(Input)`
  height: 34px;
  padding: 0;
  box-sizing: border-box;
  background-color: unset;
  border: none;

  & > input {
    padding: 6px 6px 6px 0;
    height: 100%;
    box-sizing: border-box;
    font-size: 14px;
    font-weight: 700;
    color: ${({ theme }) => theme.colors.blue[40]};
  }
`

export const ResponseText = styled(Typography).attrs({
  tag: 'span',
  size: '400-xs',
})`
  display: flex;
  align-items: center;
  gap: 2px;
`
